export const ROOT = '/PublicAF';
export const EMAILPREVIEWROOT = '/EmailPreviewAPI';
export const LOGINROOT = '/PublicLoginScreenAPI'
export const UNIQUEID = `${ROOT}/getuniqueid`;
export const SKILLS = `${ROOT}/getapplicantskills`
export const HIRING = `${ROOT}/getjobhiringddl`
export const LIST = `${ROOT}/getPublicAFPage`;
export const EXPORT = `${ROOT}/export`;
export const EXPORT_APPLICANT = `${ROOT}/exportApplicant`;
export const UPLOAD = `${ROOT}/uploadfile`;
export const COMPANY = `${LOGINROOT}/company`;
export const DETAIL = `${ROOT}/details`;
export const EMAILVALIDATION = `${ROOT}/validateEmail`;
export const EDUCATIONAL_LEVEL_NAME = `${ROOT}/geteducationlevel`;
export const SYNC_APPLICANT_TO_EMPLOYEE = `${ROOT}/syncApplicantWithEmployeeId`;
export const GET_APPLICANT_DETAIL_EMAIL_PREVIEW = `${EMAILPREVIEWROOT}/getapplicantdetailemail`;
export const UPDATE_PUBLIC_AF_WITH_EMAIL = `${ROOT}/updatepublicafwithemail`;




